module.exports = __webpack_public_path__ + "media/images/real-last-1-c7bf487bb2fdbb540e213ebdcc684876.png";